export const getNextOrdering = (currentOrdering, field) => {
    return currentOrdering === field ? `-${field}` : field;
};
